// Adapted from Axios 1.20.0's MIT-licensed platform/common/utils.js.
// Keep browser/XSRF origin semantics unchanged. Non-browser URL parsing uses
// only the explicitly configured API origin, never a fabricated destination.
import { readBackendUrl } from "./backendConfig.js";

const configuredBackend = readBackendUrl(process.env.REACT_APP_BACKEND_URL, process.env.NODE_ENV);
const hasBrowserEnv = typeof window !== "undefined" && typeof document !== "undefined";
const _navigator = (typeof navigator === "object" && navigator) || undefined;
const hasStandardBrowserEnv = hasBrowserEnv &&
  (!_navigator || ["ReactNative", "NativeScript", "NS"].indexOf(_navigator.product) < 0);
const hasStandardBrowserWebWorkerEnv = (() => (
  typeof WorkerGlobalScope !== "undefined" &&
  // eslint-disable-next-line no-undef
  self instanceof WorkerGlobalScope && typeof self.importScripts === "function"
))();
const origin = hasBrowserEnv ? window.location.href : configuredBackend;

export { hasBrowserEnv, hasStandardBrowserEnv, hasStandardBrowserWebWorkerEnv, _navigator as navigator, origin };